import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { JigsawComponent, solvSystem, sx } from '../../theme/system';
import { TypeVariants, typography } from '../../theme/typography';
import { style } from '../../utils/css';

const componentDefaults: Partial<Record<TypeVariants, string>> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
};

export type TextProps = JigsawComponent<HTMLParagraphElement> & {
  /** What kind of text to display */
  variant?: TypeVariants;

  /** Make the text muted */
  muted?: boolean;

  /** Content of the Text */
  children?: ReactNode;
};

/**
 * The Text component is the base text of the app, supporting styles from the design system
 */
const StyledText = styled('p')<TextProps & { $muted?: boolean }>(
  ({ $muted }) =>
    style({
      margin: 0,
      textColor: $muted ? 'gray-500' : 'gray-600',
    }),
  variant({
    variants: typography,
  }),
  solvSystem,
  sx,
);

const Text = ({ as, muted, variant = 'body', ...props }: TextProps) => {
  const componentType = as ?? componentDefaults[variant] ?? 'p';
  return (
    <StyledText
      as={componentType}
      $muted={muted}
      variant={variant}
      {...props}
    />
  );
};

Text.displayName = 'Text';
export default Text;
